import { useMemo } from "react";
import {
  BsChevronDoubleRight,
  BsChevronLeft,
  BsChevronRight,
} from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SimpleImageSlider from "react-simple-image-slider";
import { ChangeName, PoductsApi } from "../Redux/Action";
import Apiproduct from "./Apiproduct";
import "./Body.css";
import FrozenApiproduct from "./FrozenApiproduct";

const Body = () => {
  const promoProducts = useSelector((state) => state.ReducerPromoProductsData);
  const newProducts = useSelector((state) => state.ReducerNewProductsData);
  const dispatch = useDispatch();

  const sliderImages = useMemo(() => {
    const imageNames = ["01", "02", "03", "04", "05"];
    return imageNames.map((img) => ({
      url: `${window.imagesapi}/images/slider/${img}.webp`,
    }));
  }, []);

  const proData = useMemo(() => {
    return newProducts !== "abc" ? newProducts.newArrivalProducts : [];
  }, [newProducts]);

  const proData1 = useMemo(() => {
    return promoProducts !== "abc" ? promoProducts.promoProducts : [];
  }, [promoProducts]);

  const scroll = (containerId, distance) => {
    const container = document.getElementById(containerId);
    container?.scrollBy({ left: distance, behavior: "smooth" });
  };

  const sections = [
    {
      title: "PROMOTIONAL ITEMS",
      scrollId: "pro1",
      data: proData1,
      scrollId: "promo",
      component: <Apiproduct proData={proData1} />,
      viewMoreDep: "Promotion",
    },
    {
      title: "FASTFOOD ITEMS",
      scrollId: "pro2",
      component: <FrozenApiproduct d="0012" b="" />,
      viewMoreDep: "0012",
      viewMoreText: "Fruits & Vegitables",
    },
    {
      title: "CAKE ITEMS",
      scrollId: "pro3",
      component: <FrozenApiproduct d="0013" b="0001" />,
      viewMoreDep: "0013",
      group: "0001",
      viewMoreText: "Drinks",
    },
    {
      title: "HOT SELLING ITEMS",
      data: proData,
      scrollId: "pro4",
      component: <Apiproduct proData={proData} />,
      viewMoreDep: "New Arrivel",
    },
    {
      title: "FROZEN SNACK ITEMS",
      scrollId: "pro6",
      component: <FrozenApiproduct d="0005" b="0001" />,
      viewMoreDep: "0005",
      group: "0001",
      viewMoreText: "Frozen Foods",
    },
  ];

  return (
    <div className="all-body-items">
      {/* Slider */}
      <div className="display-image">
        <div className="slider-image">
          <div className="banner-image">
            <SimpleImageSlider
              width={"100%"}
              height={"20vw"}
              images={sliderImages}
              showBullets={false}
              showNavs={false}
              autoPlay={true}
              autoPlayDelay={2}
              style={{ position: "relative" }}
            />
          </div>
        </div>

        <div className="mobile-image-slider">
          <SimpleImageSlider
            width={"100%"}
            height={"20vw"}
            images={sliderImages}
            showBullets={false}
            showNavs={false}
            autoPlay={true}
            autoPlayDelay={2}
            style={{ position: "relative" }}
          />
        </div>
      </div>

      {/* Featured Images */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          margin: 10,
        }}
      >
        <div
          style={{
            width: "100%",
            margin: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Link
            to="/productspage"
            onClick={(e) => {
              const dep = "0012";
              dispatch(PoductsApi(dep, ""));
              dispatch(ChangeName({ dep }));
              e.stopPropagation();
            }}
          >
            <img
              style={{
                width: "100%",
                maxWidth: "600px",
                height: "auto",
                objectFit: "contain",
              }}
              src={require("./../../assets/fastfood.jpeg")}
              alt="Fast Food"
            />
          </Link>
        </div>

        <div
          style={{
            width: "100%",
            margin: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Link
            to="/productspage"
            onClick={(e) => {
              const dep = "0013";
              dispatch(PoductsApi(dep, ""));
              dispatch(ChangeName({ dep }));
              e.stopPropagation();
            }}
          >
            <img
              style={{
                width: "100%",
                maxWidth: "600px",
                height: "auto",
                objectFit: "contain",
              }}
              src={require("./../../assets/bakery.jpeg")}
              alt="Bakery"
            />
          </Link>
        </div>
      </div>

      {/* Sections */}
      {sections.map((section, idx) => (
        <div key={idx}>
          <div className="items-sec">
            <h2>{section.title}</h2>
          </div>
          <div className="items-sec">
            <div className="webexcontainer">
              <div className="webexcontainer-pro">
                <button
                  className="leftbutton"
                  onClick={() => scroll(section.scrollId, -300)}
                >
                  <BsChevronLeft />
                </button>
                <div className="webexcontainer-pro2" id={section.scrollId}>
                  {section.component}
                </div>
                <button
                  className="rightbutton"
                  onClick={() => scroll(section.scrollId, 300)}
                >
                  <BsChevronRight />
                </button>
              </div>

              <span className="haddingtag3">
                <Link
                  className="linkfount"
                  to="/productspage"
                  onClick={(e) => {
                    e.stopPropagation();
                    const dep = section.viewMoreDep;
                    const grup = section.group;
                    if (section.viewMoreText)
                      dispatch(ChangeName(section.viewMoreText));
                    dispatch(ChangeName({ dep, ...(grup && { grup }) }));
                    if (section.data) {
                      dispatch({
                        type: "get_allproducts_data",
                        data: section.data,
                      });
                    } else {
                      dispatch(PoductsApi(dep, grup || ""));
                    }
                  }}
                >
                  View More {section.title.split(" ")[0]}{" "}
                  <BsChevronDoubleRight />
                </Link>
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Body;
